import { useGetOne } from 'react-admin';

export function useClaimPolicyUtilization(claimSubmissionId) {
  return useGetOne(
    'claims',
    { id: `${claimSubmissionId}/policy-utilization` },
    { enabled: !!claimSubmissionId }
  );
}
